module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("stateoff_siteclosed_footer", [["div",{"class":"contact","data-fox-alias":"siteClosedContactText"},[["textNode",{"text":" On any questions about your membership "}],["a",{"href":"https://support.modelcentro.com/hc/en-us/requests/new","target":"_blank","rel":"nofollow"},[["textNode",{"text":"contact us"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/templates/sitepage/stateoff/footer.tpl
// module id = 796
// module chunks = 4